import * as Yup from 'yup';

export const nuevoSectorValidation = (sectores) => (
  Yup.object().shape({
    nombre: Yup.string().max(50, 'Máximo 50 caracteres').required('Campo Obligatorio').test({
      name: "sectorNoExiste",
      message: "El sector ya está registrado. Por favor, ingrese un nombre diferente.",
      test: function (value) {
        if (!sectores.some((e) => e.nombre === value)) {
          return true;
        }
        return false;
      }
    }),
    ciiu: Yup.string().nullable().required('Campo Obligatorio'),
    descripcion: Yup.string().max(200, 'Máximo 200 caracteres')
  })
)